import AsyncStorage from '@react-native-async-storage/async-storage';

const PENDING_PREMIUM_CHECKOUT_KEY = '@pending_premium_checkout';

export interface PendingPremiumCheckout {
  preselectedPlan?: string;
  preselectedProductId?: string;
  createdAt: string;
}

export const savePendingPremiumCheckout = async (
  pendingCheckout: Omit<PendingPremiumCheckout, 'createdAt'>
): Promise<void> => {
  await AsyncStorage.setItem(
    PENDING_PREMIUM_CHECKOUT_KEY,
    JSON.stringify({
      ...pendingCheckout,
      createdAt: new Date().toISOString(),
    })
  );
};

export const loadPendingPremiumCheckout = async (): Promise<PendingPremiumCheckout | null> => {
  const rawValue = await AsyncStorage.getItem(PENDING_PREMIUM_CHECKOUT_KEY);
  if (!rawValue) {
    return null;
  }

  try {
    return JSON.parse(rawValue) as PendingPremiumCheckout;
  } catch (error) {
    console.warn('[PremiumCheckout] Failed to parse pending checkout intent:', error);
    await AsyncStorage.removeItem(PENDING_PREMIUM_CHECKOUT_KEY);
    return null;
  }
};

export const clearPendingPremiumCheckout = async (): Promise<void> => {
  await AsyncStorage.removeItem(PENDING_PREMIUM_CHECKOUT_KEY);
};

export const consumePendingPremiumCheckout = async (): Promise<PendingPremiumCheckout | null> => {
  const pendingCheckout = await loadPendingPremiumCheckout();
  if (pendingCheckout) {
    await clearPendingPremiumCheckout();
  }
  return pendingCheckout;
};
